<template>
    <div v-if="displayCard" class="card">
        <div class="card-body row">
            <template v-if="avgTimeSubmitQueue != '0:00:00'">
                <div class="d-none d-sm-block col-sm border-right border-dark text-center">
                    <p v-if="!subQloading" class="m-0">{{ avgTimeSubmitQueue }}</p>
                    <p v-else class="m-0"><i class="fa fa-spinner fa-pulse fa-fw"></i></p>
                    <span class="text-muted">
                        Avg. Time in Sub Queue
                    </span>
                </div>
                <div class="d-sm-none col-sm text-center">
                    <span class="text-muted">
                        Avg. Time in Sub Queue:
                    </span>
                    <span v-if="!subQloading">{{ avgTimeSubmitQueue }}</span>
                    <span v-else><i class="fa fa-spinner fa-pulse fa-fw"></i></span>
                </div>
            </template>
            <template v-if="avgTimePostingQueue != '0:00:00'">
                <div class="d-none d-sm-block col-sm text-center">
                    <p v-if="!postQloading" class="m-0">{{ avgTimePostingQueue }}</p>
                    <p v-else class="m-0"><i class="fa fa-spinner fa-pulse fa-fw"></i></p>
                    <div class="text-muted">
                        Avg. Time in Post Queue
                    </div>
                </div>
                <div class="d-sm-none col-sm text-center">
                    <span class="text-muted">
                        Avg. Time in Post Queue:
                    </span>
                    <span v-if="!postQloading">{{ avgTimePostingQueue }}</span>
                    <span v-else><i class="fa fa-spinner fa-pulse fa-fw"></i></span>
                </div>
            </template>
            <template v-if="avgPostReacts || postReactloading">
                <div class="d-none d-sm-block col-sm border-left border-dark text-center">
                    <p v-if="!postReactloading" class="m-0">{{ avgPostReacts | round(3) }}</p>
                    <p v-else class="m-0"><i class="fa fa-spinner fa-pulse fa-fw"></i></p>
                    <div class="text-muted">
                        Avg. # Reacts
                    </div>
                </div>
                <div class="d-sm-none col-sm text-center">
                    <span class="text-muted">
                        Avg. # Reacts:
                    </span>
                    <span v-if="!postReactloading">{{ avgPostReacts | round(3) }}</span>
                    <span v-else><i class="fa fa-spinner fa-pulse fa-fw"></i></span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "StatAverages",

    props: {
        timescale: {
            type: String,
            default: "Today",
        }
    },

    data() {
        return {
            avgTimeSubmitQueue: 0,
            avgTimePostingQueue: 0,
            avgPostReacts: 0,

            subQloading: true,
            postQloading: true,
            postReactloading: true,
        }
    },

    computed: {
        displayCard: function() {
            return (this.subQloading || this.postQloading || this.postReactloading || this.avgTimeSubmitQueue != '0:00:00' || this.avgTimePostingQueue != '0:00:00' || this.avgPostReacts)
        }
    },

    created() {
        this.loadAvgTimeSubQueue()
        this.loadAvgTimePostQueue()
        this.loadAvgPostReacts()
    },

    methods: {
        loadAvgTimeSubQueue() {
            this.subQloading = true;
            var self = this;
            axios.get('api/queues/sorting/time', {
                params: {
                    timescale: this.timescale
                }
            })
            .then(function (response) {
                self.subQloading = false;
                // convert to an array (so we can easily get the length)
                self.avgTimeSubmitQueue = response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        loadAvgTimePostQueue() {
            this.postQloading = true;
            var self = this;
            axios.get('api/queues/posting/time', {
                params: {
                    timescale: this.timescale
                }
            })
            .then(function (response) {
                self.postQloading = false;
                // convert to an array (so we can easily get the length)
                self.avgTimePostingQueue = response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        loadAvgPostReacts() {
            this.postReactloading = true;
            var self = this;
            axios.get('api/posts/reactions/average', {
                params: {
                    timescale: this.timescale
                }
            })
            .then(function (response) {
                self.postReactloading = false;
                // convert to an array (so we can easily get the length)
                self.avgPostReacts = response.data;
            })
            .catch(function (error) {
                console.log(error);
            });
        },
    }
}
</script>